import type { Permission } from '@/shell/module-system'

/**
 * Capability tiers for the Uviva Samples board. These mirror the backend role
 * split in `middleware/app/api/routes/sample_requests.py`:
 *
 * - EDIT_ROLES   (`_EDIT_ROLES`)   — full read + write: create, edit, move
 *   pipeline stages, link Odoo deliveries, edit lines.
 * - CREATE_ROLES (`_CREATE_ROLES`) — the external `uviva` vendor role is added
 *   here only: it may read the full board and create a request, nothing else.
 *
 * Keep these in sync with the backend tuples — they are the source of truth for
 * which controls render.
 */
export const EDIT_ROLES: Permission[] = [
  'admin',
  'sales',
  'operations', 'purchasing',
  'outside_sales_rep',
  'inside_sales_rep',
]

export const CREATE_ROLES: Permission[] = [...EDIT_ROLES, 'uviva']
